var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 40,
    viewBox: "0 0 25 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.27723,16.72705L7.88213,1.34272c-.87515-.86588-2.03475-1.34272-3.26525-1.34272C3.38401,0,2.22553,.47947,1.35464,1.35011,.48425,2.21512,.00327,3.36758,.00002,4.59632c-.00338,1.23764,.47772,2.40212,1.355,3.2794l12.13023,12.12071L1.36804,32.12315C.49602,32.9884,.01392,34.14199,.01066,35.37211c-.00326,1.23764,.47772,2.402,1.35437,3.27877,.87001,.86989,2.03049,1.34911,3.26775,1.34911s2.39774-.47922,3.26926-1.35061l15.45196-15.48403,.0615-.06438c1.67064-1.82608,1.61014-4.62551-.13828-6.37393Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSingle);
export default __webpack_public_path__ + "static/media/arrow-single.030f625369a0dbcdc8f6946b2fd086f1.svg";
export { ForwardRef as ReactComponent };